import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import styles from "./Modal.module.css";

export default function Modal({ isOpen, onClose, title, children, className, contentClassName }) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className={styles.modalOverlay} role="presentation" onClick={onClose}>
      <div
        className={`${styles.modalContent} ${className || ""}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? "modal-title" : undefined}
        onClick={(event) => event.stopPropagation()}
      >
        {title && (
          <header className={styles.header}>
            <h2 id="modal-title">{title}</h2>

            <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Fechar modal">
              <X size={20} />
            </button>
          </header>
        )}

        <div className={`${styles.content} ${contentClassName || ""}`.trim()}>{children}</div>
      </div>
    </div>,
    document.body,
  );
}